import React, { useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import StyledMenu from "./styled";

const DropDownMenu = ({
  items,
  anchorOriginHorizontal = "right",
  anchorOriginVertical = "bottom",
  onItemClick,
}) => {
  const [anchorElem, setAnchorElem] = useState(false);

  const onOpenHandler = (event) => {
    const anchor = event?.currentTarget;

    if (anchor) {
      setAnchorElem(anchor);
    }
  };

  const handleClose = () => {
    setAnchorElem(null);
  };

  const onItemClickHandler = (id) => {
    if (onItemClick) {
      onItemClick(id);
    }
  };

  const open = Boolean(anchorElem);

  return (
    <StyledMenu>
      <div className="dropdwon-menu-action" onClick={onOpenHandler}>
        <div className="point-container">
          <span className="point" />
          <span className="point" />
          <span className="point" />
        </div>
      </div>
      <Menu
        open={open}
        id="basic-menu"
        anchorEl={anchorElem}
        onClose={handleClose}
        anchorOrigin={{
          horizontal: anchorOriginHorizontal,
          vertical: anchorOriginVertical,
        }}
        transformOrigin={{
          horizontal: anchorOriginHorizontal,
          vertical: "top",
        }}
      >
        {Array.isArray(items) &&
          items.length > 0 &&
          items.map((item) => {
            return (
              <MenuItem
                id={item.id}
                onClick={() => onItemClickHandler(item?.id)}
              >
                <div
                  style={{ display: "flex", gap: "0.2rem", color: item?.color }}
                >
                  {item?.icon && item.icon}
                  {item?.title && item?.title}
                </div>
              </MenuItem>
            );
          })}
      </Menu>
    </StyledMenu>
  );
};

export default DropDownMenu;
